import React, { useRef } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import FilterationBarContainer from "../../../components/FilterationBarContainer";
import { Col } from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";

const FilterationBar = (props) => {
	const {
		employeeList,
		selectedEmployee,
		onEmployeeChange,
		startDate,
		endDate,
		onStartDateChange,
		onEndDateChange,
	} = props;
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<FilterationBarContainer>
			<Col lg={4}>
				<Form.Group className="input-field">
					<Form.Label className="label">Employee Name</Form.Label>
					<Col>
						<CustomReactSelect
							className="ml-0"
							options={employeeList}
							value={selectedEmployee}
							onChange={(value) => onEmployeeChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>
			<Col lg={4}>
				<Form.Group className="input-field">
					<Form.Label className="label">Start Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showYearDropdown
							showMonthDropdown
							dateFormatCalendar=" " //for title
							dateFormat="dd/MM/yyyy"
							name="lStartDate"
							className="custom-container"
							onChange={(e) => onStartDateChange(e)}
							selected={startDate}
							autoComplete="off"
							//maxDate={new Date()}
							// minDate={
							// 	new Date(`1/1/${new Date().getFullYear()}`)
							// }
							maxDate={
								new Date(`12/31/${new Date().getFullYear()}`)
							}
							ref={startDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender-icon"
							color="keppel"
							onClick={() => openStartDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>
			<Col lg={4}>
				<Form.Group className="input-field">
					<Form.Label className="label">End Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showMonthDropdown
							showYearDropdown
							dateFormatCalendar=" " //for title
							dateFormat="dd/MM/yyyy"
							className={`custom-container`}
							selected={endDate}
							onChange={(e) => onEndDateChange(e)}
							name="lEndDate"
							minDate={startDate}
							maxDate={
								new Date(`12/31/${new Date().getFullYear()}`)
							}
							autoComplete="off"
							ref={endDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender-icon"
							color="keppel"
							onClick={() => openEndDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>
		</FilterationBarContainer>
	);
};

export default FilterationBar;
